module.exports = __webpack_public_path__ + "static/gallery_treehouse_5_thumb-2d2a13bfb16eb22246077a486f5dd035.jpg";